import React, { useEffect, useState, useRef } from "react";
import "./style.scss";
import { useStores } from "../../stores";
import moment from "moment";
import { useNavigate, useSearchParams } from "react-router-dom";
import CentersListView from "../../components/CentersList/centerListView";
import Header from "../../components/Header";
import InvalidKey from "../../components/InvalidKey";
import notify from "../../components/Notify/notify";
import MapIcon from "../../assets/images/map.svg";
import DateIcon from "../../assets/images/date.svg";
import CentreIcon from "../../assets/images/centre.svg";
import ValidateEmail from "../../components/Helper/emailValidate";
import { compareAsc, format } from "date-fns";
import Slider from "react-slick";
import Select from "../../components/Select";
import SuccessModal from "../../components/SuccessModal";

let flag;

let suggestSpaceFlag = false

const Home = () => {
  
  const dateRef = useRef();
  const listInnerRef = useRef();

  const [loader, setLoader] = useState(true);
  const mobiledateRef = useRef();
  const { bookingStore } = useStores();
  const [cityList, setCityList] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedCityLead, setSelectedCityLead] = useState();
  const [centerList, setCenterList] = useState([]);
  const [selecteCenter, setSelecteCenter] = useState([]);
  const [checkMailStatus, setCheckMailStatus] = useState(false);

  const today = new Date();
  const date = moment(today).format("YYYY-MM-DD");
  const weekday = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  let dateformet = new Date(date).toLocaleString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  let day = weekday[new Date(date).getDay()];
  const [selectedDate, setSelectedDate] = useState(date);
  const [mobileDate, setMobileDate] = useState(date);
  const [mobileDate2, setMobiledDate2] = useState("");
  const [selectedDate2, setSelectedDate2] = useState("");
  const [dateChange, setDateChange] = useState(false);
  const [selecteSpace, setSelecteSpace] = useState([]);
  const [accessKey, setAccessKey] = useState("");
  const [campaign, setCampaign] = useState({});
  const [accessKeyValidate, setAccessKeyValidate] = useState(false);
  const amenitiesArray = [
    { value: "VC", label: "VC" },
    { value: "LCD Screen", label: "LCD Screen" },
    { value: "Whiteboard", label: "Whiteboard" },
  ];
  const [amenities, setAmenities] = useState([
    "VC",
    "LCD Screen",
    "Whiteboard",
  ]);
  const [selectedAminities, setSelectedAminities] = useState([]);
  const [filtertime, setFiltertime] = useState([
    "8:00-12:00",
    "12:00-16:00",
    "16:00-20:00",
  ]);
  const [selectedfiltertime, setSelectedfiltertime] = useState([]);
  const [guest, setGuest] = useState(["Below 5", "5-10", "11-15", "Above 15"]);
  const [selectedGuest, setSelectedGuest] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [center, setCenter] = useState("");

  const [time, setTime] = useState("");
  const [guests, setGuests] = useState("");
  const [mobileSelectedCity, setMobileSelectedCity] = useState("");
  const [mobileCenter, setMobileCenter] = useState("");
  const [mobileAminities, setMobileAminities] = useState([]);
  let navigate = useNavigate();
  const [queryCenter, setQueryCenter] = useState("");
  const [queryCity, setQueryCity] = useState("");
  const [queryDate, setQueryDate] = useState("");
  const [queryGuest, setQueryGuest] = useState("");
  const [queryTime, setQueryTime] = useState("");
  const [queryAmenities, setQueryAmenities] = useState("");
  const [queryParams, setQueryParams] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [nameValid, setNameValid] = useState(false);
  const [emailValid, setEmailValid] = useState(false);
  const [mobilValid, setMobileValid] = useState(false);
  const [mobilValidStatus, setMobilValidStatus] = useState(false);
  const [cityValid, setCityValid] = useState(false);
  const [mobilValidDigit, setMobilValidDigit] = useState(false);
  const [suggestSpace, setSuggestSpace] = useState([]);
  const [successModal, setSuccessModal] = useState(false);
  const [leadFormStatus, setLeadFormStatus] = useState("");
  const [leadFormMessage, setLeadFormMessage] = useState("");
  const [selectedMeetingSlots, setSelectedMeetingSlots] = useState([]);

  useEffect(() => {
    let city_id = searchParams.get("city_id");
    let querydate = searchParams.get("date");
    let center_id = searchParams.get("center_id");
    let guest = searchParams.get("guest");
    let time = searchParams.get("time");
    let amenities = searchParams.get("amenities");

    if (city_id !== undefined && city_id !== null) {
      setSelectedCity(city_id);
      setQueryCity(city_id);
      getCenterListView(city_id)
      flag = city_id;
      // getCenterList(city_id);
    }
    if (querydate !== undefined && querydate !== null) {
      setSelectedDate(querydate);
      setQueryDate(querydate);
      if (date == querydate) {
        setDateChange(false);
      } else {  
        setDateChange(true);
      }
    }
    if (center_id !== undefined && center_id !== null) {
      setCenter(center_id);
      setQueryCenter(center_id);
    }
    if (guest !== undefined && guest !== null) {
      setGuests(guest);
      setQueryGuest(guest);
      handleGuest(guest);
    }
    if (time !== undefined && time !== null) {
      setQueryTime(time);
      handleFiltertime(time);
    }
    if (time !== undefined && time !== null) {
      setQueryTime(time);
      handleFiltertime(time);
    }
    if (amenities !== undefined && amenities !== null) {
      setQueryAmenities(amenities);
      handleAmenities(amenities);
    }
  }, [searchParams]);

  useEffect(() => {
    if (window.history.pushState) {
      let newurl;
      if (
        queryCity ||
        queryDate ||
        queryCenter ||
        queryGuest ||
        queryTime ||
        queryAmenities
      ) {
        let check = selectedGuest.length > 0;

        if (queryParams !== undefined && queryParams !== "") {
          newurl = `?${queryParams && queryParams}?${queryCity && `&&city_id=${queryCity}`
            }${queryDate && `&&date=${queryDate}`}${queryCenter && `&&center_id=${queryCenter}`
            }${queryGuest && `&&guest=${queryGuest}`}${queryTime && `&&time=${queryTime}`
            }${queryAmenities && `&&amenities=${queryAmenities}`}
        `;
        } else {
          newurl = `?${queryCity && `&&city_id=${queryCity}`}${queryDate && `&&date=${queryDate}`
            }${queryCenter && `&&center_id=${queryCenter}`}${queryGuest && `&&guest=${queryGuest}`
            }${queryTime && `&&time=${queryTime}`}${queryAmenities && `&&amenities=${queryAmenities}`
            }
      `;
        }
        window.history.pushState({ path: newurl }, "", newurl);
      } else {
        searchParams.delete("city_id");
        searchParams.delete("center_id");
        searchParams.delete("date");
        searchParams.delete("guest");
        searchParams.delete("time");
        searchParams.delete("amenities");
        setSearchParams(searchParams);
      }
    }
    // let newurl = `${queryCity && `&&city_id=${queryCity}`}${
    //   queryDate && `&&date=${queryDate}`
    // }${queryCenter && `&&center_id=${queryCenter}`}${
    //   guests && `&&guest=${guests}`
    // }`;
    // setSearchParams(newurl);
  }, [
    queryCity,
    queryDate,
    queryCenter,
    queryGuest,
    queryTime,
    queryAmenities,
  ]);

  useEffect(() => {
    let newvar = window.location.pathname;
    let key = newvar.split("/")[1];
    setAccessKey(key);
    getCampaign(key);
  }, [window.location.pathname]);
  
  useEffect(() => {
    let location = window.location.href;
    let query_params = location.split("?")[1];
    // console.log(query_params)
    let checkString = true;
    checkString = query_params ? query_params.startsWith("&&") : false;
    if (!checkString) {
      setQueryParams(query_params);
    } else {
      setQueryParams("");
    }
  }, [window.location.href]);

  useEffect(() => {
    getCityList();
  }, []);

  useEffect(() => {
    format(new Date(), "yyyy-MM-dd");
    const dates = [new Date(selectedDate)];
    dates.sort(compareAsc);
    let datefor = dates[0];
    let tempDate = datefor.toString().split(" ");
    let formeteddate = `${tempDate[0]}, ${tempDate[2]} ${tempDate[1]}, ${tempDate[3]}`;
    setSelectedDate2(formeteddate);
  }, [selectedDate]);

  useEffect(() => {
    format(new Date(), "yyyy-MM-dd");
    const dates = [new Date(mobileDate)];
    dates.sort(compareAsc);
    let datefor = dates[0];
    let tempDate = datefor.toString().split(" ");
    let formeteddate = `${tempDate[0]}, ${tempDate[2]} ${tempDate[1]}, ${tempDate[3]}`;
    setMobiledDate2(formeteddate);
  }, [mobileDate]);

  useEffect(() => {
    if (cityList.length > 0) {
      getCenterList(selectedCity);
      // getspacelists(selectedCity);
    }
  }, [
    cityList,
    center,
    selectedCity,
    selectedDate,
    selectedGuest?.[0],
    selectedfiltertime?.[0],
    selectedAminities.length,
  ]);

  useEffect(()=>{
    if(selectedCity !== ''){
      getCenterListView(selectedCity);
      getspacelists(selectedCity);
    }
  },[selectedCity])

  const getCityList = async () => {
    setLoader(true);
    await bookingStore.getCityList((response) => {
      if (response?.data?.status === 1) {
        setCityList(response?.data?.data);
        if (flag == undefined) {
          if (selectedCity === undefined || selectedCity == "") {
            setSelectedCity(response?.data?.data[0].id);
          }
        }
        setLoader(false);
      } else {
        console.log("error");
        setLoader(false);
      }
    });
  };

  const getCampaign = async (key) => {
    setLoader(true);
    let params = `access_key=${key}`;
    await bookingStore.getCampaign(params, (response) => {
      if (response?.data?.status === 1) {
        if (response?.data?.data?.inventory_id != 0) {
          navigate(`/payment/${key}`);
        } else {
          setCampaign(response?.data?.data);
          //setSelectedCity(response?.data?.data?.city_id);
          setAccessKeyValidate(false);
        }
      } else {
        setAccessKeyValidate(true);
      }
    });
  };

  const getspacelists = async (city) =>{
   
    let params = `city_id=${city}&inventory_type_id=3`;

    bookingStore.getspacelist(params,(response)=>{
      if (response?.data?.status === 1) {
        setSelecteSpace(response?.data?.data);
        let centerList = response?.data?.data?.space;
        // setCenterList(centerList);
        if (center == "") {
          setSelecteCenter(centerList);
        }
        console.log(response?.data?.data)
        setLoader(false);
      } else {
        console.log("error");
        setLoader(false);
      }
    })
  }

 
  const getCenterList = async (city) => {
    setLoader(true);
    let pax_start = 0;
    let pax_end = 0;
    let start_time = 0;
    let end_time = 0;

    if (selectedGuest?.length > 0) {
      let guestData = selectedGuest;
      let tempGuest = guestData[0];
      if (tempGuest === "Below 5") {
        pax_start = 1;
        pax_end = 4;
      } else if (tempGuest === "5-10") {
        pax_start = 5;
        pax_end = 10;
      } else if (tempGuest === "11-15") {
        pax_start = 11;
        pax_end = 15;
      } else if (tempGuest === "Above 15") {
        pax_start = 15;
        pax_end = 100;
      }
    }
    if (selectedfiltertime?.length > 0) {
      let timeData = selectedfiltertime;
      let tempTime = timeData[0];
      if (tempTime === "8:00-12:00") {
        let temp = tempTime?.split("-");
        start_time = `${selectedDate} 0${temp[0]?.split("am")[0]}:00`;
        end_time = `${selectedDate} ${temp[1]?.split("pm")[0]}:00`;
      } else if (tempTime === "12:00-16:00") {
        let temp = tempTime?.split("-");
        start_time = `${selectedDate} ${temp[0]?.split("pm")[0]}:00`;
        end_time = `${selectedDate} ${temp[1]?.split("pm")[0]}:00`;
      } else if (tempTime === "16:00-20:00") {
        let temp = tempTime?.split("-");
        start_time = `${selectedDate} ${temp[0]?.split("pm")[0]}:00`;
        end_time = `${selectedDate} ${temp[1]?.split("pm")[0]}:00`;
      }
    } else {
      start_time = `${selectedDate} 00:00`;
    }
    let obj = {
      mr_vc: 0,
      lcd: 0,
      projector: 0,
      whiteboard: 0,
    };
    if (selectedAminities?.length > 0) {
      let aminiData = selectedAminities;
      aminiData.map((item) => {
        if (item === "VC") {
          obj.mr_vc = 1;
        } else if (item === "LCD Screen") {
          obj.lcd = 1;
        } else if (item === "Projector") {
          obj.projector = 1;
        } else if (item === "Whiteboard") {
          obj.whiteboard = 1;
        }
      });
    }
    let params = `city_id=${city}${obj.lcd == 1 ? `&lcd=${obj.lcd}` : ""}${obj.mr_vc == 1 ? `&mr_vc=${obj.mr_vc}` : ""
      }${obj.projector == 1 ? `&projector=${obj.projector}` : ""}${obj.whiteboard == 1 ? `&whiteboard=${obj.whiteboard}` : ""
      }${pax_start !== 0 ? `&pax_start=${pax_start}` : ""}${pax_end !== 0 ? `&pax_end=${pax_end}` : ""
      }${start_time !== 0 ? `&start_time=${start_time}` : ""}${end_time !== 0 ? `&end_time=${end_time}` : ""
      }${center !== "" ? `&space_id=${center}` : ""}`;

    bookingStore.getCenterList(params, (response) => {
      if (response?.data?.status === 1) {
        let invenotriesId = [];
        let centerList = response?.data?.data?.space;
        setCenterList(centerList);
        // getspacelists(city);
       
        // if (center == "") {
        //   setSelecteCenter(centerList);
        // }
       console.log(centerList.length,"<=====centerList.length====")
        if(centerList.length >= 0){
          getSuggestCenterList(selectedCity);
        }

        // setSelecteSpace(response?.data?.data);
        setLoader(false);
      } else {
        setCenterList([]);
        setSelecteCenter([]);
        setSelecteSpace([]);
        setLoader(false);
      }
    });
  };


  const getSuggestCenterList = async (city) => {
    let start_time = 0;
    if (selectedfiltertime?.length > 0) {
      let timeData = selectedfiltertime;
      let tempTime = timeData[0];
      if (tempTime === "8:00-12:00") {
        let temp = tempTime?.split("-");
        start_time = `${selectedDate} 0${temp[0]?.split("am")[0]}:00`;
      } else if (tempTime === "12:00-16:00") {
        let temp = tempTime?.split("-");
        start_time = `${selectedDate} ${temp[0]?.split("pm")[0]}:00`;
      } else if (tempTime === "16:00-20:00") {
        let temp = tempTime?.split("-");
        start_time = `${selectedDate} ${temp[0]?.split("pm")[0]}:00`;
      }
    } else {
      start_time = `${selectedDate} 00:00`;
    }

    let params = `city_id=${city}${start_time !== 0 ? `&start_time=${start_time}` : ""}`;

    await bookingStore.getCenterList(params, (response) => {
      if (response?.data?.status === 1) {
        let invenotriesId = [];
        let centerList = response?.data?.data?.space;
        setSuggestSpace(centerList);
        
        setSelecteSpace(response?.data?.data);
        setLoader(false);
      } else {
        setSuggestSpace([]);
        setLoader(false);
      }
    });
  };

  const getMobileCenterList = async (city) => {
    let params = `city_id=${city}`;
    await bookingStore.getCenterList(params, (response) => {
      if (response?.data?.status === 1) {
        setCenterList(response?.data?.data?.space);
        if (center == "") {
          setSelecteCenter(response?.data?.data?.space);
        }
        setLoader(false);
      } else {
        setCenterList([]);
        setSelecteCenter([]);
        setLoader(false);
      }
    });
  };

  const getCenterListView = async (city) => {
    let params = `city_id=${city}`;
    await bookingStore.getCenterList(params, (response) => {
      if (response?.data?.status === 1) {
          setSelecteCenter(response?.data?.data?.space);
      } else {
        setSelecteCenter([]);
        setLoader(false);
      }
    });
  };

  const getFilterData = async (id) => {
    const newCenters = selecteCenter.filter(
      (selecteCenter) => selecteCenter.id == id
    );
    setCenterList(newCenters);
  };

  const handleAmenities = (item, index) => {
    let tempAmenities = [];
    if (typeof item !== "object") {
      tempAmenities = selectedAminities;

      if (!tempAmenities.includes(item)) {
        tempAmenities.push(item);
        setQueryAmenities(item);
      } else {
        tempAmenities.splice(tempAmenities.indexOf(item), 1);
        setQueryAmenities("");
      }
    } else {
      tempAmenities = item?.map((i) => {
        return i.value;
      });
    }
    setSelectedAminities((prevState) => tempAmenities);
    setAmenities((prevState) => [...amenities]);
    setCenterList([]);
  };

  const handleMobileAmenities = (item, index) => {
    let tempAmenities = [];
    if (typeof item !== "object") {
      tempAmenities = mobileAminities;

      if (!tempAmenities.includes(item)) {
        tempAmenities.push(item);
      } else {
        tempAmenities.splice(tempAmenities.indexOf(item), 1);
      }
    } else {
      tempAmenities = item?.map((i) => {
        return i.value;
      });
    }
    setMobileAminities((prevState) => tempAmenities);
  };

  const handleFiltertime = (item, index) => {
    setQueryTime(item);
    let tempFilterTime = selectedfiltertime;

    if (!tempFilterTime.includes(item)) {
      if (tempFilterTime.length < 0) tempFilterTime.push(item);
      else {
        tempFilterTime = [];
        tempFilterTime.push(item);
        setQueryTime(item);
      }
    } else {
      tempFilterTime.splice(tempFilterTime.indexOf(item), 1);
      setQueryTime("");
    }
    setSelectedfiltertime((prevState) => tempFilterTime);
    setFiltertime((prevState) => [...filtertime]);
  };

  const handleGuest = (item, index) => {
    let tempGuest = selectedGuest;

    if (!tempGuest.includes(item)) {
      if (tempGuest.length < 0) tempGuest.push(item);
      else {
        tempGuest = [];
        tempGuest.push(item);
        setQueryGuest(item);
      }
    } else {
      tempGuest.splice(tempGuest.indexOf(item), 1);
      setQueryGuest("");
    }
    setSelectedGuest((prevState) => tempGuest);
    setGuest((prevState) => [...guest]);
    // if(queryGuest == ""){
    //   setCenterList([]);
    // }
  };

  const handleLeadForm = async (e) => {
    e.preventDefault();
    setCheckMailStatus(false);
    setMobilValidStatus(false);
    setMobilValidDigit(false);
    if (name === "") {
      // notify("Please enter name", "danger");
      setNameValid(true);
      // return;
    }
    if (mobile === "") {
      // notify("Please enter mobile number", "danger");
      setMobileValid(true);
      // return;
    }
    if (email === "") {
      // notify("Please enter email", "danger");
      setEmailValid(true);
      // return;
    }
    if (selectedCity === "") {
      // notify("Please select city", "danger");
      setCityValid(true);
      // return;
    }
    if (name === "" || mobile === "" || email === "" || selectedCity === "") {
      return;
    }

    let utm_source = searchParams.get("utm_source");
    let utm_medium = searchParams.get("utm_medium");
    let utm_campaign = searchParams.get("utm_campaign");
    let payloadData = {
      name: name,
      mobile: mobile,
      email: email,
      city_id:
        selectedCityLead !== undefined
          ? parseInt(selectedCityLead)
          : cityList[0]?.id,
      inv_type: 3,
      url: window.location.href,
      utm_medium: utm_medium !== null ? utm_medium : "",
      utm_campaign: utm_campaign !== null ? utm_campaign : "",
      utm_source: utm_source !== null ? utm_source : "",
    };
    // console.log(payloadData);
    // setLoader(true);
    await bookingStore.getLeadForm(payloadData, (response) => {
      if (response?.data?.status === 1) {
        // notify("Thankyou. We've received your enquiry");
        setSuccessModal(true);
        setLeadFormStatus("Success");
        setLeadFormMessage("Thankyou. We've received your enquiry");
        setName("");
        setMobile("");
        setEmail("");
        setSelectedCityLead("");
        // setLoader(false);
      } else {
        setSuccessModal(true);
        setLeadFormStatus("Failed");
        setLeadFormMessage(response?.response?.data?.data[0]);
        // notify("Lead submission failed", "danger");
        // setLoader(false);
      }
    });
  };

  var settings = {
    dots: true,
    autoplay: true,
    infinite: true,
    speed: 2000,
  };

  const findYourSpace = (e) => {
    e.preventDefault();
    sessionStorage.setItem(
      "selectedFilterData",
      JSON.stringify({
        time,
        guests,
        mobileCenter,
        mobileDate,
        mobileSelectedCity,
        selecteCenter,
        queryParams
      })
    );
    let aminities = [];
    let selectedAminities = []
    mobileAminities?.map((item) => {
      aminities.push({ label: item, value: item });
      selectedAminities.push(item);
    });
    sessionStorage.setItem(
      "mobileAminities",
      JSON.stringify({
        aminities,
      })
    );
    sessionStorage.setItem(
      "selectedAminities",
      JSON.stringify({
        selectedAminities,
      })
    );
    navigate(`/filter-page/${accessKey}?${queryParams == undefined && queryParams}`);
  };

  // const onScroll = () => {
  //   alert('scroll')
  //   // if (listInnerRef.current) {
  //   //   const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
  //   //   if (scrollTop + clientHeight === scrollHeight) {
  //   //     console.log(scrollTop,"====",scrollHeight,"====",clientHeight)
  //   //     // This will be triggered after hitting the last element.
  //   //     // API call should be made here while implementing pagination.
  //   //   }
  //   // }
  // };
  
  return (
    <>
      {accessKeyValidate == true ? (
        <>
          <InvalidKey />
        </>
      ) : (
        <>
          <Header
            accessKey={accessKey}
            queryParams={queryParams && queryParams}
          />
          {loader ? (
            <div className="loader"></div>
          ) : (
            <div className="home-container">
              <section className="booking-listing-section">
                <div className="mob-slider">
                  {/* <div
                    id="homeMobSlider"
                    className="carousel slide"
                    data-ride="carousel"
                  >
                    <ul className="carousel-indicators">
                      <li
                        data-target="#homeMobSlider"
                        data-slide-to="0"
                        className="active"
                      ></li>
                      <li data-target="#homeMobSlider" data-slide-to="1"></li>
                      <li data-target="#homeMobSlider" data-slide-to="2"></li>
                    </ul>
                    <div className="carousel-inner">
                      <div className="carousel-item active">
                        <img
                          src={require("../../assets/images/image1.jpg")}
                          alt="Banner 1"
                          className="banne-image"
                        />
                        <div className="carousel-caption">
                          <h3 className="banner-heading">{`${centerList.length > 0 &&
                            selecteSpace.number_of_space
                            } CENTRES IN  ${selecteSpace.city_name == undefined
                              ? ""
                              : selecteSpace.city_name
                            }`}</h3>
                          <div className="banner-sub-text">
                            <p className="banner-city">
                              {selecteSpace.location_text}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="carousel-item">
                        <img
                          src={require("../../assets/images/image2.jpg")}
                          alt="Banner 2"
                          className="banne-image"
                        />
                        <div className="carousel-caption">
                          <h3 className="banner-heading">{centerList.length > 0 && `${selecteSpace.number_of_space} CENTRES IN ${selecteSpace.city_name}`}</h3>
                          <div className="banner-sub-text">
                            {selecteSpace.location_text}
                          </div>
                        </div>
                      </div>
                      <div className="carousel-item">
                        <img
                          src={require("../../assets/images/image3.jpg")}
                          alt="Banner 3"
                          className="banne-image"
                        />
                        <div className="carousel-caption">
                          <h3 className="banner-heading">{centerList.length > 0 && `${selecteSpace.number_of_space} CENTRES IN ${selecteSpace.city_name}`}</h3>
                          <div className="banner-sub-text">
                            {selecteSpace.location_text}
                          </div>
                        </div>
                      </div>
                    </div> */}
                  {/* <a className="carousel-control-prev" href="#homeMobSlider" data-slide="prev">
                <span className="carousel-control-prev-icon"></span>
              </a>
              <a className="carousel-control-next" href="#homeMobSlider" data-slide="next">
                <span className="carousel-control-next-icon"></span>
              </a>  */}
                  {/* </div> */}
                  <Slider {...settings}>
                    <div className="swebslider">
                      <img src={require("../../assets/images/image1.jpg")} />
                      {/* <div className="carousel-stext">
                        <h3 className="banner-heading">
                          {`${selecteSpace.number_of_space
                            } CENTRES IN ${selecteSpace.city_name == undefined
                              ? ""
                              : selecteSpace.city_name
                            }`}
                        </h3>
                        <div className="banner-sub-text">
                          <p className="banner-city">{selecteSpace.location_text}</p>
                        </div>
                      </div> */}
                    </div>
                    <div className="swebslider">
                      <img src={require("../../assets/images/image2.jpg")} />
                      {/* <div className="carousel-stext">
                        <h3 className="banner-heading">
                          {`${selecteSpace.number_of_space
                            } CENTRES IN ${selecteSpace.city_name == undefined
                              ? ""
                              : selecteSpace.city_name
                            }`}
                        </h3>
                        <div className="banner-sub-text">
                          <p className="banner-city">{selecteSpace.location_text}</p>
                        </div>
                      </div> */}
                    </div>
                    <div className="swebslider">
                      <img src={require("../../assets/images/image3.jpg")} />
                      {/* <div className="carousel-stext">
                        <h3 className="banner-heading">
                          {`${selecteSpace.number_of_space
                            } CENTRES IN ${selecteSpace.city_name == undefined
                              ? ""
                              : selecteSpace.city_name
                            }`}
                        </h3>
                        <div className="banner-sub-text">
                          <p className="banner-city">{selecteSpace.location_text}</p>
                        </div>
                      </div> */}
                    </div>
                  </Slider>
                  <div className="web-slider-content">
                    <div className="carousel-stext">
                      <h3 className="banner-heading">
                        {/* {console.log(selecteSpace.length)} */}
                        {selecteSpace?.number_of_space > 2 ? (
                          <>
                            {`${selecteSpace?.number_of_space} CENTRES IN ${selecteSpace?.city_name == undefined
                                ? ""
                                : selecteSpace?.city_name
                              }`}
                          </>
                        ) : (
                          <>
                            {`${selecteSpace?.city_name == undefined
                                ? ""
                                : selecteSpace?.city_name
                              }`}
                          </>
                        )}
                      </h3>
                      <div className="banner-sub-text">
                        <p className="banner-city">
                          {selecteSpace.location_text}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-md-4 col-12">
                      <div className="filter-box">
                        <div className=" mobileview-dnone">
                          <div className="location-box">
                            <div className="form-group icon-group">
                              <img
                                src={MapIcon}
                                alt="Location"
                                className="map-icon"
                              />
                              <select
                                className="form-control filter-field"
                                id="sel1"
                                value={selectedCity}
                                onChange={(e) => {
                                  e.preventDefault();
                                  // console.log("selected " + e.target.value);'
                                  setSelectedCity(e.target.value);
                                  setQueryCity(e.target.value);
                                  setQueryCenter("");
                                  // getCityList();
                                  setCenter("");
                                }}
                              >
                                {cityList?.map((item) => {
                                  return (
                                    <>
                                      <option
                                        className="cityoptionfield"
                                        value={item?.id}
                                      >
                                        {item?.name}
                                      </option>
                                    </>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                          <div
                            className="date-box"
                            onClick={() => {
                              dateRef.current.showPicker();
                            }}
                          >
                            <div className="form-group icon-group">
                              <img
                                src={DateIcon}
                                alt="Location"
                                className="map-icon"
                              />
                              <input
                                ref={dateRef}
                                data-date-format="DD MMMM YYYY"
                                className="form-control filter-field date"
                                value={selectedDate}
                                onChange={(e) => {
                                  if (e.target.value == date) {
                                    sessionStorage.setItem(
                                      "selectedDate",
                                      JSON.stringify(e.target.value)
                                    );
                                    setSelectedDate(e.target.value);
                                    setDateChange(false);
                                  } else {
                                    sessionStorage.setItem(
                                      "selectedDate",
                                      JSON.stringify(e.target.value)
                                    );
                                    setSelectedDate(e.target.value);
                                    setDateChange(true);
                                  }
                                  setQueryDate(e.target.value);
                                  setCenterList([]);
                                }}
                                type="date"
                                min={date}
                              />
                              <span className="open-button">
                                <img
                                  src={require("../../assets/images/down.png")}
                                  alt="Date"
                                  className="date-icon"
                                />
                              </span>
                              {selectedDate !== "" ? (
                                <p className="date-home">{selectedDate2}</p>
                              ) : (
                                <p className="date-home">{"dd-mm-yyyy"}</p>
                              )}
                            </div>
                          </div>
                          <div className="center-box">
                            <div className="form-group icon-group">
                              <img
                                src={CentreIcon}
                                alt="Location"
                                className="map-icon"
                              />
                              <select
                                className="form-control filter-field"
                                id="sel1"
                                value={center}
                                onChange={(e) => {
                                  if (e.target.value !== "") {
                                    // getFilterData(e.target.value);
                                    setCenter(e.target.value);
                                    setQueryCenter(e.target.value);
                                  } else {
                                    setCenter("");
                                    setQueryCenter("");
                                    // getCenterList(selectedCity);
                                    // setCenter("")
                                    // setCenterList([]);
                                  }
                                }}
                              >
                                <option value="">Select Center</option>
                                {selecteCenter?.map((item) => {
                                  return (
                                    <option value={item?.id}>
                                      {item?.name}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className=" mobileview-dblock">
                          <div className="location-box">
                            <div className="form-group icon-group">
                              <img
                                src={MapIcon}
                                alt="Location"
                                className="map-icon"
                              />
                              <select
                                className="form-control filter-field"
                                id="sel1"
                                value={mobileSelectedCity}
                                onChange={(e) => {
                                  e.preventDefault();
                                  setMobileSelectedCity(e.target.value);
                                  setCenter("");
                                  getMobileCenterList(e.target.value);
                                }}
                              >
                                {cityList?.map((item) => {
                                  return (
                                    <>
                                      <option
                                        className="cityoptionfield"
                                        value={item?.id}
                                      >
                                        {item?.name}
                                      </option>
                                    </>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                          <div
                            className="date-box"
                            onClick={() => {
                              mobiledateRef.current.showPicker();
                            }}
                          >
                            <div className="form-group icon-group">
                              <img
                                src={DateIcon}
                                alt="Location"
                                className="map-icon"
                              />
                              <input
                                ref={mobiledateRef}
                                data-date-format="DD MMMM YYYY"
                                className="form-control filter-field date"
                                value={mobileDate}
                                onChange={(e) => {
                                  if (e.target.value == date) {
                                    setMobileDate(e.target.value);
                                  } else {
                                    setMobileDate(e.target.value);
                                  }
                                }}
                                type="date"
                                min={date}
                              />
                              <span className="open-button">
                                <img
                                  src={require("../../assets/images/down.png")}
                                  alt="Date"
                                  className="date-icon"
                                />
                              </span>
                              {mobileDate !== "" ? (
                                <p className="date-home">{mobileDate2}</p>
                              ) : (
                                <p className="date-home">{"dd-mm-yyyy"}</p>
                              )}
                            </div>
                          </div>
                          <div className="center-box">
                            <div className="form-group icon-group">
                              <img
                                src={CentreIcon}
                                alt="Location"
                                className="map-icon"
                              />
                              <select
                                className="form-control filter-field"
                                id="sel1"
                                value={mobileCenter}
                                onChange={(e) => {
                                  if (e.target.value !== "") {
                                    setMobileCenter(e.target.value);
                                  } else {
                                    setMobileCenter("");
                                  }
                                }}
                              >
                                <option value="">Select Center</option>
                                {selecteCenter?.map((item) => {
                                  return (
                                    <option value={item?.id}>
                                      {item?.name}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="guests-box mobileview-dnone">
                          <h3 className="filter-heading">No. of Guests</h3>
                          <div
                            className="filter-select-box"
                            key={selectedGuest.length}
                          >
                            {guest?.map((item, index) => {
                              return (
                                <a
                                  key={Math.random}
                                  className={
                                    selectedGuest.includes(item)
                                      ? "filter-select-field ame-active"
                                      : "filter-select-field"
                                  }
                                  onClick={() => {
                                    handleGuest(item, index);
                                  }}
                                >
                                  {item}
                                </a>
                              );
                            })}
                          </div>
                        </div>

                        <div className="d-flex">
                          <div className="center-box mobileview-dblock mr-2">
                            <div className="form-group icon-group mb-0">
                              {/* <img
                                src={CentreIcon}
                                alt="Location"
                                className="map-icon"
                              /> */}
                              <select
                                className="form-control mobfield-noicon"
                                id="sel1"
                                value={guests}
                                onChange={(e) => {
                                  if (e.target.value !== "") {
                                    // handleGuest(e.target.value);
                                    setGuests(e.target.value);
                                  } else {
                                    // setGuests("");
                                    handleGuest("");
                                  }
                                }}
                              >
                                <option value="">No. of Guests</option>
                                {guest?.map((item, index) => {
                                  return <option value={item}>{item}</option>;
                                })}
                              </select>
                            </div>
                          </div>
                          <div className="center-box mobileview-dblock">
                            <div className="form-group icon-group mb-0">
                              {/* <img
                                src={CentreIcon}
                                alt="Location"
                                className="map-icon"
                              /> */}
                              <select
                                className="form-control mobfield-noicon"
                                id="sel1"
                                value={time}
                                onChange={(e) => {
                                  if (e.target.value !== "") {
                                    // handleFiltertime(e.target.value);
                                    setTime(e.target.value);
                                  } else {
                                    setTime("");
                                    // handleFiltertime("");
                                  }
                                }}
                              >
                                <option value="">Time</option>
                                {filtertime?.map((item, index) => {
                                  return <option value={item}>{item}</option>;
                                })}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="center-box mobileview-dblock selectame">
                          <div className="form-group icon-group centreIcon-container">
                            <Select
                              isMulti={true}
                              placeholder="Select Amenities"
                              options={amenitiesArray}
                              className={"filter-field"}
                              onChange={(e) => {
                                if (e !== "") {
                                  handleMobileAmenities(e);
                                } else {
                                  handleMobileAmenities("");
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className="center-box mobileview-dblock">
                          <button
                            className="mob-fullbtn"
                            onClick={(e) => {
                              findYourSpace(e);
                            }}
                          >
                            FIND YOUR SPACE
                          </button>
                        </div>
                        <div className="time-box mobileview-dnone">
                          <h3 className="filter-heading">Time</h3>
                          <div
                            className="filter-select-box"
                            key={selectedfiltertime.length}
                          >
                            {filtertime?.map((item, index) => {
                              return (
                                <a
                                  key={Math.random}
                                  className={
                                    selectedfiltertime.includes(item)
                                      ? "filter-select-field ame-active"
                                      : "filter-select-field"
                                  }
                                  onClick={() => {
                                    handleFiltertime(item, index);
                                  }}
                                >
                                  {item}
                                </a>
                              );
                            })}
                          </div>
                        </div>
                        <div className="amenities-box mobileview-dnone">
                          <h3 className="filter-heading">Amenities</h3>
                          <div
                            className="filter-select-box"
                            key={selectedAminities.length}
                          >
                            {amenities?.map((item, index) => {
                              return (
                                <a
                                  key={Math.random}
                                  className={
                                    selectedAminities.includes(item)
                                      ? "filter-select-field ame-active"
                                      : "filter-select-field"
                                  }
                                  onClick={() => {
                                    handleAmenities(item, index);
                                  }}
                                >
                                  {item}
                                </a>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8">
                      {/* <div className="web-slider">
                        <div
                          id="homeWebSlider"
                          className="carousel slide"
                          data-ride="carousel"
                        >
                          <ul className="carousel-indicators">
                            <li
                              data-target="#homeWebSlider"
                              data-slide-to="0"
                              className="active"
                            ></li>
                            <li
                              data-target="#homeWebSlider"
                              data-slide-to="1"
                            ></li>
                            <li
                              data-target="#homeWebSlider"
                              data-slide-to="2"
                            ></li>
                          </ul>
                          <div className="carousel-inner">
                            <div className="carousel-item active">
                              <img
                                src={require("../../assets/images/image1.jpg")}
                                alt="Banner 1"
                                className="banne-image"
                              />
                              <div className="carousel-caption">
                                <h3 className="banner-heading">{
                                  centerList?.length > 0 &&
                                  `${selecteSpace.number_of_space
                                  } CENTRES IN ${selecteSpace.city_name == undefined
                                    ? ""
                                    : selecteSpace.city_name
                                  }`}</h3>
                                <div className="banner-sub-text">
                                  {centerList?.length > 0 && selecteSpace.location_text}
                                </div>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <img
                                src={require("../../assets/images/image2.jpg")}
                                alt="Banner 2"
                                className="banne-image"
                              />
                              <div className="carousel-caption">
                                <h3 className="banner-heading">{centerList?.length > 0 && `${selecteSpace.number_of_space} CENTRES IN ${selecteSpace.city_name}`}</h3>
                                <div className="banner-sub-text">
                                  {centerList?.length > 0 && selecteSpace.location_text}
                                </div>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <img
                                src={require("../../assets/images/image3.jpg")}
                                alt="Banner 3"
                                className="banne-image"
                              />
                              <div className="carousel-caption">
                                <h3 className="banner-heading">{centerList?.length > 0 && `${selecteSpace.number_of_space} CENTRES IN ${selecteSpace.city_name}`}</h3>
                                <div className="banner-sub-text">
                                  {centerList?.length > 0 && selecteSpace.location_text}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* <a className="carousel-control-prev" href="#homeWebSlider" data-slide="prev">
                      <span className="carousel-control-prev-icon"></span>
                    </a>
                    <a className="carousel-control-next" href="#homeWebSlider" data-slide="next">
                      <span className="carousel-control-next-icon"></span>
                    </a>  */}
                      {/* </div>
                      </div> */}
                      <div className="web-slider">
                        <Slider {...settings}>
                          <div className="swebslider">
                            <img
                              src={require("../../assets/images/image1.jpg")}
                            />
                            {/* <div className="carousel-stext">
                              <h3 className="banner-heading">
                                {`${selecteSpace.number_of_space
                                  } CENTRES IN ${selecteSpace.city_name == undefined
                                    ? ""
                                    : selecteSpace.city_name
                                  }`}
                              </h3>
                              <div className="banner-sub-text">
                                <p className="banner-city">{selecteSpace.location_text}</p>
                              </div>
                            </div> */}
                          </div>
                          <div className="swebslider">
                            <img
                              src={require("../../assets/images/image2.jpg")}
                            />
                            {/* <div className="carousel-stext">
                              <h3 className="banner-heading">
                                {`${selecteSpace.number_of_space
                                  } CENTRES IN ${selecteSpace.city_name == undefined
                                    ? ""
                                    : selecteSpace.city_name
                                  }`}
                              </h3>
                              <div className="banner-sub-text">
                                <p className="banner-city">{selecteSpace.location_text}</p>
                              </div>
                            </div> */}
                          </div>
                          <div className="swebslider">
                            <img
                              src={require("../../assets/images/image3.jpg")}
                            />
                            {/* <div className="carousel-stext">
                              <h3 className="banner-heading">
                                {`${selecteSpace.number_of_space
                                  } CENTRES IN ${selecteSpace.city_name == undefined
                                    ? ""
                                    : selecteSpace.city_name
                                  }`}
                              </h3>
                              <div className="banner-sub-text">
                                <p className="banner-city">{selecteSpace.location_text}</p>
                              </div>
                            </div> */}
                          </div>
                        </Slider>
                        <div className="web-slider-content">
                          <div className="carousel-stext">
                            <h3 className="banner-heading">
                              {selecteSpace?.number_of_space > 2 ? (
                                <>
                                  {`${selecteSpace.number_of_space
                                    } CENTRES IN ${selecteSpace.city_name == undefined
                                      ? ""
                                      : selecteSpace.city_name
                                    }`}
                                </>
                              ) : (
                                <>
                                  {`${selecteSpace.city_name == undefined
                                      ? ""
                                      : selecteSpace.city_name
                                    }`}
                                </>
                              )}
                            </h3>
                            <div className="banner-sub-text">
                              <p className="banner-city">
                                {selecteSpace.location_text}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="container listing-container" >
                        {centerList?.length > 0 ? (
                          centerList?.map((item, index) => {
                            if (item?.inventories?.length > 0)
                              return (
                                <>
                                  <CentersListView
                                    refs={listInnerRef}
                                    centerList={centerList}
                                    key={Math.random()}
                                    item={item}
                                    date={selectedDate}
                                    navigate={navigate}
                                    searchParamsVal={queryParams}
                                    accessKey={accessKey}
                                    changeDate={dateChange}
                                    cityid={selectedCity}
                                    pickedDate={selectedDate}
                                    meetingslot={item.inventories}
                                    index={index}
                                  />
                                </>
                              );
                          })
                        ) : (
                          <div>
                            <div className=" mobileview-dnone">
                              <p className="nodata-heading">
                                Oops, selected space unavailable.
                              </p>
                              <p className="nodatafound-subheading  mb-3">
                                EXPLORE ALTERNATIVES.
                              </p>
                            </div>
                            <div className=" mobileview-dblock ">
                              <p className="nodata-heading text-left">
                                Oops,
                                <br /> selected space unavailable.
                              </p>
                              <p className="nodatafound-subheading text-left  mb-3">
                                EXPLORE ALTERNATIVES.
                              </p>
                            </div>
                            {suggestSpace?.map((item, index) => {
                              return (
                                <>
                                  <CentersListView
                                    key={Math.random()}
                                    item={item}
                                    date={selectedDate}
                                    navigate={navigate}
                                    searchParamsVal={queryParams}
                                    accessKey={accessKey}
                                    changeDate={dateChange}
                                    cityid={selectedCity}
                                    pickedDate={selectedDate}
                                  />
                                </>
                              );
                            })}
                          </div>
                        )}
                      </div>
                      <div className="contact-box">
                        <h3 className="contact-heading">
                          Still don’t see what you’re looking for?
                        </h3>
                        <p className="contact-sub-heading">
                          Get a member of our team to do the searching- we’ll
                          help you find the right workspace.
                        </p>
                        <form className="contact-form">
                          <div className="row">
                            <div className="col-md-3 form-col mob-pd">
                              <input
                                type="text"
                                className="form-control contact-field"
                                placeholder="Name"
                                value={name}
                                onChange={(e) => {
                                  setName(e.target.value);
                                  setNameValid(false);
                                }}
                              />
                              {nameValid && (
                                <p className="text-danger">Please enter name</p>
                              )}
                            </div>

                            <div className="col-md-3 form-col mob-pd">
                              <input
                                type="tel"
                                className="form-control contact-field"
                                placeholder="Mobile Number"
                                value={mobile}
                                maxLength={10}
                                pattern="[0-9]*"
                                onBlur={(e) => {
                                  if (e.target.value.length === 10) {
                                    setMobile(e.target.value);
                                  } else {
                                    setMobilValidDigit(true);
                                    return;
                                  }
                                }}
                                onChange={(e) => {
                                  setMobileValid(false);
                                  setMobilValidStatus(false);
                                  setMobilValidDigit(false);
                                  if (e.target.validity.valid) {
                                    setMobile(e.target.value);
                                  } else {
                                    // notify(
                                    //   "Mobile should contain only number",
                                    //   "danger"
                                    // );
                                    setMobilValidStatus(true);
                                    return;
                                  }
                                }}
                              />
                              {mobilValid && (
                                <p className="text-danger">
                                  Please enter mobile number
                                </p>
                              )}
                              {!mobilValid && mobilValidStatus && (
                                <p className="text-danger">
                                  Mobile should contain only number
                                </p>
                              )}
                              {!mobilValid &&
                                !mobilValidStatus &&
                                mobilValidDigit && (
                                  <p className="text-danger">
                                    Mobile number can only be of 10 digits
                                  </p>
                                )}
                            </div>
                            <div className="col-md-3 form-col mob-pd">
                              <input
                                type="email"
                                className="form-control contact-field"
                                placeholder="Email Id"
                                value={email}
                                onBlur={(e) => {
                                  let checkMail;
                                  checkMail = ValidateEmail(e.target.value);
                                  if (!checkMail) {
                                    // notify(
                                    //   "Please enter correct email",
                                    //   "danger"
                                    // );
                                    setEmail("");
                                    setCheckMailStatus(true);
                                  } else {
                                    setCheckMailStatus(false);
                                  }
                                }}
                                onChange={(e) => {
                                  setEmail(e.target.value);
                                  setEmailValid(false);
                                }}
                              />
                              {emailValid && (
                                <p className="text-danger">
                                  Please enter email
                                </p>
                              )}
                              {checkMailStatus && (
                                <p className="text-danger">
                                  Please enter correct email
                                </p>
                              )}
                            </div>
                            <div className="col-md-3 form-col mob-pd">
                              <select
                                className="form-control contact-field"
                                id="sel1"
                                value={selectedCityLead}
                                onChange={(e) => {
                                  setSelectedCityLead(e.target.value);
                                }}
                              >
                                {cityList?.map((item) => {
                                  return (
                                    <>
                                      <option
                                        className="cityoptionfield"
                                        value={item?.id}
                                      >
                                        {item?.name}
                                      </option>
                                    </>
                                  );
                                })}
                              </select>
                              {cityValid && (
                                <p className="text-danger">
                                  Please Select City
                                </p>
                              )}
                            </div>
                            <div className="col-md-12">
                              <button
                                type="submit"
                                className="btn-contact"
                                onClick={handleLeadForm}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </form>
                        <p className="contact-sub-heading">
                          Or call us on 1860 258 6633
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <div className="modal fade show">
                <div className="modal-dialog login">
                  <div className="modal-content">
                    {/* <!-- Modal Header --> */}
                    <div className="modal-header login">
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                      >
                        &times;
                      </button>
                    </div>

                    {/* <!-- Modal body --> */}
                    <div className="modal-body login">
                      <h3 className="login-heading">Log in</h3>
                      <p className="login--sub-heading">
                        Sign in using your registered mobile no.
                      </p>
                      <p className="login--sub-heading">or email id.</p>
                      <form className="login-form">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control login-field"
                            placeholder="Email Id/Mobile no."
                            id="email"
                            required
                          />
                        </div>
                        <div className="form-group">
                          <img
                            src={require("../../assets/images/eye.png")}
                            alt="Password"
                            className="eye-icon"
                          />
                          <input
                            type="password"
                            className="form-control login-field"
                            placeholder="Password"
                            id="pwd"
                          />
                        </div>
                        <button type="submit" className="login-btn">
                          Log in
                        </button>
                        <div className="form-group form-check">
                          <label className="form-check-label">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />{" "}
                            Remember me
                          </label>
                          <h3 className="accout-text">
                            <a href="#">Forgot Password</a>
                          </h3>
                        </div>
                      </form>
                      <h3 className="create-text">
                        Don’t have account?{" "}
                        <a href="#" className="accout-text">
                          Sign Up
                        </a>
                      </h3>
                    </div>

                    {/* Modal footer  */}
                  </div>
                </div>
              </div>
              <SuccessModal
                show={successModal}
                hide={() => {
                  setSuccessModal(false);
                }}
                status={leadFormStatus}
                message={leadFormMessage}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Home;
